export const SANDBOX_TYPES = [
  { key: 'wms', label: 'WMS' },
  { key: 'cart', label: 'Cart' },
  { key: 'carrier', label: 'Carrier' },
];

export const RESOURCES_BY_TYPE = {
  wms: [
    { key: 'orders', label: 'Orders', apiPath: 'wms/orders' },
    {
      key: 'inbound-shipments',
      label: 'Inbound Shipments',
      apiPath: 'wms/inbound-shipments',
    },
    { key: 'returns', label: 'Returns', apiPath: 'wms/returns' },
    { key: 'products', label: 'Products', apiPath: 'wms/products' },
    { key: 'inventory', label: 'Inventory', apiPath: 'wms/inventory' },
    { key: 'warehouses', label: 'Warehouses', apiPath: 'wms/warehouses' },
    {
      key: 'warehouse-customers',
      label: 'Warehouse Customers',
      apiPath: 'wms/warehouse-customers',
    },
    {
      key: 'shipping-methods',
      label: 'Shipping Methods',
      apiPath: 'wms/shipping-methods',
    },
    { key: 'billing', label: 'Billing', apiPath: 'wms/billing' },
  ],
  cart: [
    { key: 'orders', label: 'Orders', apiPath: 'cart/orders' },
    { key: 'products', label: 'Products', apiPath: 'cart/products' },
    { key: 'warehouses', label: 'Warehouses', apiPath: 'cart/warehouses' },
  ],
  carrier: [
    {
      key: 'invoice-line-items',
      label: 'Invoice Line Items',
      apiPath: 'carrier/invoice-line-items',
    },
    { key: 'files', label: 'Files', apiPath: 'carrier/files' },
  ],
  erp: [
    { key: 'sales-orders', label: 'Sales Orders', apiPath: 'erp/sales-orders' },
    {
      key: 'sales-order-shipments',
      label: 'Sales Order Shipments',
      apiPath: 'erp/sales-order-shipments',
    },
    {
      key: 'purchase-orders',
      label: 'Purchase Orders',
      apiPath: 'erp/purchase-orders',
    },
    {
      key: 'purchase-order-receipts',
      label: 'Purchase Order Receipts',
      apiPath: 'erp/purchase-order-receipts',
    },
    { key: 'inventory', label: 'Inventory', apiPath: 'erp/inventory' },
    { key: 'items', label: 'Items', apiPath: 'erp/items' },
    { key: 'locations', label: 'Locations', apiPath: 'erp/locations' },
    { key: 'customers', label: 'Customers', apiPath: 'erp/customers' },
    { key: 'vendors', label: 'Vendors', apiPath: 'erp/vendors' },
    { key: 'employees', label: 'Employees', apiPath: 'erp/employees' },
  ],
};

export const ACTIONS_BY_RESOURCE = {
  wms: {
    orders: [
      {
        key: 'update',
        label: 'Update',
        variant: 'secondary',
        disabledWhen: (row) => row.status === 'cancelled' || row.status === 'fulfilled',
      },
      {
        key: 'fulfill',
        label: 'Fulfill',
        method: 'PUT',
        endpoint: (id) => `sandbox/simulate/orders/${id}/fulfill`,
        variant: 'primary',
        disabledWhen: (row) => row.status === 'cancelled' || row.status === 'fulfilled',
      },
      {
        key: 'cancel',
        label: 'Cancel',
        method: 'PUT',
        endpoint: (id) => `wms/orders/${id}/cancel`,
        variant: 'danger',
        disabledWhen: (row) => row.status === 'cancelled' || row.status === 'fulfilled',
      },
    ],
    'inbound-shipments': [
      {
        key: 'update',
        label: 'Update',
        variant: 'secondary',
        disabledWhen: (row) => row.status !== 'open',
      },
      {
        key: 'receive',
        label: 'Receive',
        method: 'PUT',
        endpoint: (id) => `wms/inbound-shipments/${id}/receive`,
        variant: 'primary',
        buildBody: (row) => ({
          line_items: (row.line_items || []).map((li) => ({
            sku: li.sku,
            quantity: li.expected_quantity || li.quantity || 1,
          })),
        }),
        disabledWhen: (row) => row.status !== 'open',
      },
    ],
    returns: [
      {
        key: 'update',
        label: 'Update',
        variant: 'secondary',
        disabledWhen: (row) => row.status === 'cancelled' || row.status === 'received',
      },
      {
        key: 'receive',
        label: 'Receive',
        method: 'PUT',
        variant: 'primary',
        opensModal: 'receiveReturn',
        disabledWhen: (row) => row.status === 'cancelled' || row.status === 'received',
      },
    ],
    products: [{ key: 'update', label: 'Update', variant: 'secondary' }],
    inventory: [{ key: 'update', label: 'Update', variant: 'secondary' }],
    warehouses: [{ key: 'update', label: 'Update', variant: 'secondary' }],
    'warehouse-customers': [],
    'shipping-methods': [],
    billing: [],
  },
  cart: {
    orders: [
      {
        key: 'create-shipment',
        label: 'Create Shipment',
        method: 'POST',
        endpoint: (id) => `cart/orders/${id}/shipments`,
        variant: 'primary',
        needsInput: true,
        inputFields: [
          { key: 'tracking_number', label: 'Tracking Number', type: 'text' },
          { key: 'tracking_url', label: 'Tracking URL', type: 'text' },
          { key: 'carrier_name', label: 'Carrier', type: 'text' },
          { key: 'shipping_method_name', label: 'Shipping Method', type: 'text' },
        ],
      },
      {
        key: 'refund',
        label: 'Refund',
        method: 'POST',
        endpoint: (id) => `cart/orders/${id}/refund`,
        variant: 'danger',
        needsInput: true,
        inputFields: [
          { key: 'line_items', label: 'Line Items (JSON)', type: 'json' },
        ],
      },
    ],
    products: [
      {
        key: 'adjust-inventory',
        label: 'Adjust Inventory',
        method: 'PUT',
        endpoint: (id) => `cart/products/${id}/adjust-inventory`,
        variant: 'primary',
        needsInput: true,
        inputFields: [
          { key: 'quantity', label: 'Quantity', type: 'number' },
          { key: 'warehouse_id', label: 'Warehouse ID', type: 'text' },
        ],
      },
    ],
    warehouses: [],
  },
  carrier: {
    'invoice-line-items': [],
    files: [],
  },
};

export const TABLE_PRIORITY_FIELDS = {
  orders: [
    'id',
    'order_number',
    'status',
    'created_date',
    'total_price',
    'channel',
  ],
  'inbound-shipments': [
    'id',
    'purchase_order_number',
    'status',
    'created_date',
    'warehouse_id',
    'expected_arrival_date',
  ],
  returns: ['id', 'order_id', 'status', 'created_date', 'warehouse_id'],
  products: ['id', 'sku', 'name', 'created_date', 'active', 'unit_price'],
  inventory: [
    'id',
    'sku',
    'name',
    'onhand',
    'committed',
    'fulfillable',
    'sellable',
  ],
  warehouses: ['id', 'name', 'code'],
  'warehouse-customers': ['id', 'name', 'email'],
  'shipping-methods': ['id', 'name', 'carrier_name', 'scac'],
  billing: [
    'id',
    'charge_type',
    'amount',
    'currency_code',
    'object_type',
    'created_date',
  ],
  'invoice-line-items': [
    'id',
    'invoice_id',
    'tracking_number',
    'charge_description',
    'net_cost',
    'gross_cost',
  ],
  files: ['file_name', 'file_type', 'created_date', 'download_url'],
};

export const STRIP_FIELDS = {
  orders: ['id', 'shipments', 'trading_partner', 'shipping_method'],
  'inbound-shipments': ['id', 'receipts'],
  returns: ['id'],
  products: ['id', 'inventory_items'],
  inventory: ['id'],
  warehouses: ['id'],
};

export const STATUS_LABEL = {
  partially_fulfilled: 'partial',
};

export const STATUS_BADGE = {
  open: 'status-open',
  confirmed: 'status-confirmed',
  processing: 'status-processing',
  picked: 'status-picked',
  packed: 'status-packed',
  partially_fulfilled: 'status-partially_fulfilled',
  fulfilled: 'status-fulfilled',
  backordered: 'status-backordered',
  exception: 'status-exception',
  cancelled: 'status-cancelled',
  'in-transit': 'status-in-transit',
  receiving: 'status-receiving',
  received: 'status-received',
  other: 'status-other',
  closed: 'status-closed',
};

// internal to how we store the row, never shown
const HIDDEN_FIELDS = [
  'connection_id',
  'trackstar_tags',
];

// shown, but the server assigns them, so the editor never offers them
const READ_ONLY_FIELDS = [
  'trackstar_created_date',
  'trackstar_updated_date',
];

export const isHiddenField = (key) => HIDDEN_FIELDS.includes(key);

export const isEditableField = (key) => (
  !isHiddenField(key) && !READ_ONLY_FIELDS.includes(key)
);

export const canCreate = (sandboxType) => sandboxType === 'wms';

// cart only auto-generates orders and products, not warehouses
const CART_CREATABLE_RESOURCES = ['orders', 'products'];

// the api has no create endpoint for these
const WMS_READ_ONLY_RESOURCES = ['warehouse-customers', 'shipping-methods', 'billing'];

export const canCreateResource = (sandboxType, resourceKey) => {
  if (sandboxType === 'wms') return !WMS_READ_ONLY_RESOURCES.includes(resourceKey);
  if (sandboxType === 'cart') return CART_CREATABLE_RESOURCES.includes(resourceKey);
  return false;
};

const resolveSubSchemaExamples = (ref, spec) => {
  const schemaName = ref.split('/').pop();
  const subSchema = spec?.components?.schemas?.[schemaName];
  if (!subSchema) return null;
  const result = {};
  Object.entries(subSchema.properties ?? {}).forEach(([field, def]) => {
    if (def.enum) {
      const [firstEnum] = def.enum;
      result[field] = firstEnum;
    } else if ('example' in def) result[field] = def.example;
  });
  return Object.keys(result).length > 0 ? result : null;
};

export const PUT_RESOURCE_PATHS = {
  orders: '/wms/orders/{order_id}',
  'inbound-shipments': '/wms/inbound-shipments/{inbound_shipment_id}',
  returns: '/wms/returns/{return_id}',
  products: '/wms/products/{product_id}',
  inventory: '/wms/inventory/{inventory_id}',
  warehouses: '/wms/warehouses/{warehouse_id}',
};

// returns { fields: Set, nested: { fieldKey: Set } }
export const buildUpdateFieldSet = (spec, resourceKey) => {
  if (!spec) return null;
  const path = PUT_RESOURCE_PATHS[resourceKey];
  if (!path) return null;
  const schemaRef = spec.paths?.[path]?.put?.requestBody?.content?.['application/json']?.schema?.$ref;
  if (!schemaRef) return null;
  const schema = spec.components?.schemas?.[schemaRef.split('/').pop()];
  const fields = new Set(Object.keys(schema?.properties ?? {}));
  const nested = {};
  Object.entries(schema?.properties ?? {}).forEach(([field, def]) => {
    const refName = (def.$ref ?? def.items?.$ref ?? '').split('/').pop();
    if (!refName) return;
    const subSchema = spec.components?.schemas?.[refName];
    if (subSchema) nested[field] = new Set(Object.keys(subSchema.properties ?? {}));
  });
  return { fields, nested };
};

export const buildSpecEnums = (spec, resourcePath, method = 'post') => {
  if (!spec) return {};
  const inputSchemaRef = spec.paths?.[resourcePath]?.[method]?.requestBody?.content?.['application/json']?.schema?.$ref;
  if (!inputSchemaRef) return {};
  const schemaName = inputSchemaRef.split('/').pop();
  const schema = spec.components?.schemas?.[schemaName];
  if (!schema) return {};

  const enums = {};
  Object.entries(schema.properties ?? {}).forEach(([field, def]) => {
    if (def.enum) {
      enums[field] = def.enum;
    } else if (def.$ref) {
      const subSchemaName = def.$ref.split('/').pop();
      const subSchema = spec.components?.schemas?.[subSchemaName];
      const subEnums = {};
      Object.entries(subSchema?.properties ?? {}).forEach(([subField, subDef]) => {
        if (subDef.enum) subEnums[subField] = subDef.enum;
      });
      if (Object.keys(subEnums).length > 0) enums[field] = subEnums;
    } else if (def.type === 'array' && def.items?.$ref) {
      const itemSchemaName = def.items.$ref.split('/').pop();
      const itemSchema = spec.components?.schemas?.[itemSchemaName];
      const itemEnums = {};
      Object.entries(itemSchema?.properties ?? {}).forEach(([subField, subDef]) => {
        if (subDef.enum) itemEnums[subField] = subDef.enum;
      });
      if (Object.keys(itemEnums).length > 0) enums[field] = itemEnums;
    }
  });
  return enums;
};

// returns { fields: Set, nested: { fieldKey: Set } }
export const buildSpecRequired = (spec, resourcePath, method = 'post') => {
  if (!spec) return { fields: new Set(), nested: {} };
  const inputSchemaRef = spec.paths?.[resourcePath]?.[method]?.requestBody?.content?.['application/json']?.schema?.$ref;
  if (!inputSchemaRef) return { fields: new Set(), nested: {} };
  const schemaName = inputSchemaRef.split('/').pop();
  const schema = spec.components?.schemas?.[schemaName];
  const fields = new Set(schema?.required ?? []);
  const nested = {};
  Object.entries(schema?.properties ?? {}).forEach(([field, def]) => {
    const refName = (def.$ref ?? def.items?.$ref ?? '').split('/').pop();
    if (!refName) return;
    const subSchema = spec.components?.schemas?.[refName];
    if (subSchema?.required?.length) nested[field] = new Set(subSchema.required);
  });
  return { fields, nested };
};

export const buildSandboxDefaultsFromSpec = (spec) => {
  if (!spec) return {};
  const resourcePaths = {
    orders: '/wms/orders',
    'inbound-shipments': '/wms/inbound-shipments',
    returns: '/wms/returns',
    products: '/wms/products',
    inventory: '/wms/inventory',
    warehouses: '/wms/warehouses',
  };

  const defaults = {};
  Object.entries(resourcePaths).forEach(([resourceKey, path]) => {
    const inputSchemaRef = spec.paths?.[path]?.post?.requestBody?.content?.['application/json']
      ?.schema?.$ref;
    if (!inputSchemaRef) return;
    const inputSchemaName = inputSchemaRef.split('/').pop();
    const inputSchema = spec?.components?.schemas?.[inputSchemaName];
    const resourceDefaults = {};
    Object.entries(inputSchema?.properties ?? {}).forEach(([field, def]) => {
      if (def.enum) {
        const [firstEnum] = def.enum;
        resourceDefaults[field] = firstEnum;
      } else if (def.type === 'array' && def.items?.$ref) {
        const resolved = resolveSubSchemaExamples(def.items.$ref, spec);
        if (resolved) resourceDefaults[field] = [resolved];
      } else if (def.$ref) {
        const resolved = resolveSubSchemaExamples(def.$ref, spec);
        if (resolved) resourceDefaults[field] = resolved;
      } else if ('example' in def) {
        resourceDefaults[field] = def.example;
      }
    });
    defaults[resourceKey] = resourceDefaults;
  });
  return defaults;
};
